import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
// import.meta.env.VITE_API_URL,

import axios from 'axios';
import store from '@/store';
import api from '../api/index';
// 根据环境不同引入不同api地址
import { baseApi } from '@/config';
import Bridge from '@/utils/bridge.js';
// create an axios instance
var service = axios.create({
  baseURL: baseApi,
  // url = base api url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 30000 // request timeout
});

var reqNum = 0;
var forbitReq = [api.follow, api.unFollow, api.thumbs, api.collect, api.comments, api.postComments, api.signUp];
function startLoading() {
  if (reqNum === 0) {
    _Toast.loading({
      forbidClick: true,
      duration: 0
    });
  }
  reqNum++;
}
function endLoading() {
  closeLoading();
}
function closeLoading() {
  if (reqNum <= 0) return;
  reqNum--;
  if (reqNum === 0) {
    _Toast.clear();
  }
}

// request拦截器 request interceptor
service.interceptors.request.use(function (config) {
  // 不传递默认开启loading
  if (!config.hideloading) {
    startLoading();
    // loading
    // Toast.loading({
    //   forbidClick: true,
    //   duration: 0
    // })
  }
  // if (store.getters.token && store.getters.userId) {
  //   config.headers['APP-USER-ID'] = store.getters.userId
  //   config.headers['APP-LOGIN-TOKEN'] = store.getters.token
  // } else {
  //   config.headers['APP-CONTENT-ENCRYPTED'] = 0
  //   config.headers['APP-LANGUAGE-TYPE'] = store.getters.language
  //   config.headers['APP-SEND-DATE'] = new Date().getTime()
  // }

  // console.log('config: ' + JSON.stringify(config))
  // 1. 判断是否app登录 uid token
  var appInfo = JSON.parse(localStorage.getItem('appParams'));
  if (appInfo && (appInfo.token == '' || appInfo.uid == '')) {
    console.log('app用户未登录:' + config.url);
    forbitReq.forEach(function (itm) {
      if (config.url.includes(itm)) {
        if (itm == api.comments && config.method == 'get') {
          // return;
        } else {
          var u = navigator.userAgent;
          if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
            if (window.Android) {
              window.Android.unLogin();
            }
          } else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
            Bridge.callhandler('unLogin', null, function (response) {});
          }
          return;
        }
      }
    });
  } else {
    if (store.state.socialToken) {
      if (config.params && config.params.type === 'share') {} else {
        config.headers['authorization'] = 'Bearer  ' + store.state.socialToken;
      }
    } else {
      if (localStorage.getItem('socialToken')) {
        if (config.params && config.params.type === 'share') {} else {
          config.headers['authorization'] = 'Bearer  ' + localStorage.getItem('socialToken');
        }
      }
    }
  }
  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug
  return Promise.reject(error);
});
// respone拦截器
service.interceptors.response.use(function (response) {
  endLoading();
  var res = response.data;
  if (res.Code && res.Code !== 0 && res.Code !== -4003 && res.Code !== -4004) {
    // 登录超时,重新登录
    // if (res.status === 401) {
    //   // store.dispatch('FedLogOut').then(() => {
    //   //   location.reload()
    //   // })
    // }
    return Promise.reject(res || 'error');
  } else {
    return Promise.resolve(res);
  }
}, function (error) {
  _Toast.clear();
  console.log('err' + error); // for debug
  return Promise.reject(error);
});
export default service;